const OrderNotification = (state, action) => {
  if (!state) {
    return {
      order: {},
      unreadCount: 0
    }
  }

  switch (action.type) {
  case 'NOTIFICATION':
    return { ...state, order: action.order }  
  case 'UNREADCOUNT':
    return { ...state, unreadCount: action.unreadCount}
  default:
    return state
  }
}

export default OrderNotification


// WEBPACK FOOTER //
// ./src/reducer/notification.js